import { LoanStatus, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { Milestone } from '@/components/modules/Funnel/types/Milestone';
import { Step } from '@/components/modules/Funnel/types/Step';

export const StepsDefinitionsOrder = [
  {
    statuses: [LoanStatus.STATUS_INITIAL],
    tId: 'INITIAL',
    associatedMilestone: Milestone.INITIAL,
  },
  {
    statuses: [LoanStatus.STATUS_ANALYSING],
    tId: 'PERSONAL_INFORMATION',
  },
  {
    statuses: [LoanStatusExternal.REQUESTED],
    tId: 'REQUESTED',
    associatedMilestone: Milestone.REQUESTED,
  },
  {
    statuses: [LoanStatusExternal.APPROVED],
    tId: 'APPROVED',
    associatedMilestone: Milestone.APPROVED,
  },
  {
    statuses: [LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED],
    tId: 'OTP',
  },
  {
    statuses: [LoanStatus.STATUS_CONTRACT_SIGNED],
    tId: 'DOWNPAYMENT',
  },
  {
    statuses: [LoanStatusExternal.CONFIRMED],
    tId: 'CONFIRMED',
    associatedMilestone: Milestone.CONFIRMED,
  },
  {
    statuses: [LoanStatusExternal.CAPTURED],
    tId: 'CAPTURED',
  },
] as Step[];
